import { FRAME_GROUPS } from '../../store/financialFrames/stateType';

export const SIDE_SHEET_SECTIONS = FRAME_GROUPS;
